import React from "react";

const fmt = (n) => Number(n ?? 0).toLocaleString("en-IN");

/**
 * Card-style filter for Masters grids (e.g. All / Active / Inactive): each card shows a count and,
 * when `total` is given, its share with a thin bar. Wraps responsively; one selected at a time.
 *
 * items: [{ id, label, count, icon, tone: "primary" | "success" | "muted" }]
 * wide: full-width row with one column per card (pages with many cards, e.g. Rating); wraps to 3 / 2 columns on
 * smaller screens.
 */
export default function FilterTabs({ items, value, onChange, total, ariaLabel = "Filter", wide = false }) {
  return (
    <div
      className={`mst-filter-tabs${wide ? " mst-filter-tabs--wide" : ""}`}
      style={wide ? { "--cols": items.length } : undefined}
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {items.map((item) => {
        const selected = item.id === value;
        const share = total ? Math.round(((item.count ?? 0) * 100) / total) : null;
        const showShare = share !== null && item.count !== total;
        return (
          <button
            key={item.id}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`mst-filter-tab is-${item.tone ?? "primary"}${selected ? " is-selected" : ""}`}
            onClick={() => onChange(item.id)}
          >
            <span className="mst-filter-tab__icon" aria-hidden="true">
              <i className={item.icon} />
            </span>
            <span className="mst-filter-tab__body">
              <span className="mst-filter-tab__label" title={item.label}>
                {item.label}
              </span>
              <span className="mst-filter-tab__value">
                <span className="mst-filter-tab__count">{fmt(item.count)}</span>
                {showShare && <span className="mst-filter-tab__share">{share}%</span>}
              </span>
              {showShare && (
                <span className="mst-filter-tab__bar" aria-hidden="true">
                  <span style={{ width: `${share}%` }} />
                </span>
              )}
            </span>
            {selected && <i className="fas fa-check-circle mst-filter-tab__tick" aria-hidden="true" />}
          </button>
        );
      })}
    </div>
  );
}
